/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { PARSED_CREATE_USER_DATA_FRAGMENT } from '../fragments/ParsedCreateUserDataFragment'

export const PARSE_CREATE_USER_CSV = gql`
  mutation ParseCreateUserCsv($file: Upload!) {
    parseCreateUserCsv(file: $file) {
      ...ParsedCreateUserData
    }
  }
  ${PARSED_CREATE_USER_DATA_FRAGMENT}
`
